<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { ref, onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getWithActivity } from "@/api/assets";
  import { iscode } from "@/utils/app";
  let defSearch = {
    page: 1,
    limit: 5,
    id: ''
  };
  export default {
    components: {},
    name: "relationList",
    props: {
      id: {
        type: Number
      },
    },
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        listLoading: false,
        total: 1,
      });
      let columns = [
        {
          title: "关联活动ID",
          dataIndex: "id",
          key: "id",
          width: 120
        },
        {
          title: "活动名称",
          dataIndex: "act_name",
          key: "act_name",
        },
        {
          title: "活动类型",
          dataIndex: "act_type",
          key: "act_type"
        },
        {
          title: "状态",
          dataIndex: "act_status_text",
          key: "act_status_text",
          width: 120
        }
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async () => {
        state.listLoading = true;
        let res = await getWithActivity({ ...search.value, id: props.id }).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>